module.exports = __webpack_public_path__ + "img/title.83422943.png";